globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Public = appCustomerSpace.Modals.Public || {};

appCustomerSpace.Modals.Public.LastArticlesFilter = (function(superClass) {
  utils.extend(LastArticlesFilter, superClass);

  function LastArticlesFilter($html) {
    return LastArticlesFilter.__super__.constructor.apply(this, arguments);
  }

  $.extend(LastArticlesFilter.prototype, {
    init: function() {
      return LastArticlesFilter.__super__.init.apply(this, arguments);
    },

    callbackSuccess: function(data) {
      if(data && data.response == 1) {
        $('#filters-resume').replaceWith(data.html);
        if (data.preview_html) {
          appCustomerSpace.currentController._reloadPreview(data.preview_html);
        }
        LastArticlesFilter.__super__.callbackSuccess.apply(this, arguments);
      } else {
        LastArticlesFilter.__super__.callbackSuccess.apply(this, arguments);
      }
    }
  });

  return LastArticlesFilter;
})(appCustomerSpace.Modal);
